import React from 'react'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {MegaMenu} from './MegaMenu'
import {useIntl} from 'react-intl'
import { useUserroles } from '../../../../Atom/contextProviders/Atomqueryprovider'
import { useAuth } from '../../../../app/modules/auth'

export function MenuInner() {
  const intl = useIntl()
  const { currentUser } = useAuth()
  
  // Get user roles data
  const {
    isLoading: userrolesloading,
    isSuccess: userrolessuccess,
    data: userrolesdata,
  } = useUserroles(Number(currentUser?.user_role_id))

  // Check if user is admin
  const isUserAdmin = () => {
    if (!userrolessuccess || !userrolesdata?.data) return false
    // Adjust this condition based on your actual role data structure
    return userrolesdata.data.role_name === 'Admin' || userrolesdata.data.is_admin === true
  }

  return (
    <>
      <MenuItem title={intl.formatMessage({id: 'MENU.DASHBOARD'})} to='/home' />
      <MenuItem 
        title="Profit and Loss" 
        to={isUserAdmin() ? '/profitorloss' : '#'} 
        disabled={!isUserAdmin()}
      
      />
    </>
  )
}